export default "__VITE_ASSET__ed9ae4b9__"